import { PageValue } from "../contexts/page";
import { BlocksValue } from "../contexts/blocks";
import { TypesValue } from "../contexts/types";
import { useContext, useState, useEffect } from "react";

export default function useSources(path) {
  const tree = useContext(PageValue);
  const blocks = useContext(BlocksValue);
  const types = useContext(TypesValue);
  const [sources, setSources] = useState([]);

  useEffect(() => {
    if (tree) {
      const sources = [];
      let _tree = { ...tree };

      path.forEach((p) => {
        const block = blocks.find((x) => !!_tree && x.name === _tree.component);

        if (!block) {
        } else if (block.sources) {
          block.sources.forEach((s) => {
            const _s = {
              name: /\[(.*?)\]/g.test(s.displayName)
                ? s.displayName.replace(/\[(.*?)\]/g, (m, g) => {
                    const type = types.find((x) => x.name === _tree.props[g]);
                    if (type) {
                      return type.displayName;
                    }
                    return "type";
                  })
                : s.displayName,
              code: _tree.id + s.name,
              returnType: _tree.props[s.type] ? _tree.props[s.type] : s.type,
              returnList: s.list,
              params: [],
              category: _tree.name,
            };
            sources.push(_s);
          });
        }
        if (_tree) {
          _tree = _tree.children[p];
        }
      });
      setSources(sources);
    }
  }, [tree, path, types]);

  return sources;
}
